import { Button, ButtonProps, Spinner } from "react-bootstrap"
import { FaSave } from "react-icons/fa"

export function LoadingButton({isLoading, icon=<FaSave style={{position: "relative", top: "-0.125em"}} />, ...props}: ButtonProps & { isLoading: boolean, icon?: React.ReactNode }){
  return <Button {...props} disabled={isLoading || props.disabled}>
    {isLoading ? <Spinner className="me-2" animation="border" size="sm" /> : icon && <span className="me-2">{icon}</span>}
    {props.children}
  </Button>
}